/**
 * Convert CSS pixel coordinates (from rendered PDF page) to Meon API PDF point coordinates.
 *
 * Meon uses standard PDF coordinates: bottom-left origin, y increases upward.
 * CSS/browser uses top-left origin, y increases downward.
 * We must invert the Y axis when converting.
 *
 * The y_coordinate sent to Meon represents the bottom edge of the signature box
 * measured from the bottom of the page.
 *
 * @param {Object} cssRect - The bounding box in CSS pixels relative to the rendered page container.
 *   { left, top, width, height }
 * @param {Object} pageSize - The original PDF page size in points (72 PPI) from pdf.js.
 *   { width, height }
 * @param {number} renderedWidth - The actual rendered width of the page container in CSS pixels.
 * @returns {Object} - { x_coordinate, y_coordinate, width, height } in PDF points (integers).
 */
export function cssToMeonCoordinates(cssRect, pageSize, renderedWidth) {
  const scale = renderedWidth / pageSize.width;

  const boxWidthPt = Math.round(cssRect.width / scale);
  const boxHeightPt = Math.round(cssRect.height / scale);
  const xPt = Math.round(cssRect.left / scale);

  // CSS top → distance from page top in points → invert to bottom-left origin
  const topPt = cssRect.top / scale;
  const yPt = Math.round(pageSize.height - topPt - boxHeightPt);

  return {
    x_coordinate: xPt,
    y_coordinate: yPt,
    width: boxWidthPt,
    height: boxHeightPt,
  };
}

/**
 * Default signature box size in CSS pixels (before scaling).
 * Roughly 103×50 PDF points at 1x scale.
 */
export const DEFAULT_BOX = { width: 150, height: 60 };
